import React from "react";
import { ButtonText } from "@loanbossinc/component-library";
import "./filterHeaderStyles.css";

const FilterHeader = ({ title, onReset, resetLabel = "Reset Amounts" }) => (
  <div className="filter-panel-filter-filterheader-wrapper">
    <div>{title}</div>
    <ButtonText onClick={onReset} label={resetLabel} />
  </div>
);

export default FilterHeader;
